



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';


@Component
export default class SideBar extends Vue {
  @Prop() public path: string;
  @Prop() public defaultRoute: string;
  @Prop() public accordion: string;
  public items: Common.Favorite[] = new Array(0);
  public sharedItems: Common.Favorite[] = new Array(0);
  public message: string = '';
  public showDialog: boolean = false;
  public created() {
    this.$root.$on('sidebar', this.reload);
  }
  public beforeMount() {
    this.reload();
  }

  public reload() {
    //お気に入りをロードする
    if (this.path != undefined) {

      // const query = new Common.FavoriteQuery(Common.favoriteFlags.Private);
      // query.path = this.path;
      // this.$api.execute(query).then(res => {
      //   const temp = res as Common.LoadResult;        
      //   this.items = temp.result;
      //   this.$forceUpdate();
      // });

      // const queryShared = new Common.FavoriteQuery(Common.favoriteFlags.System);
      // queryShared.path = this.path;
      // this.$api.execute(queryShared).then(res => {
      //   const temp = res as Common.LoadResult;
      //   this.sharedItems = temp.result;
      //   this.$forceUpdate();
      // });

      const query = new Common.FavoriteQuery(Common.favoriteFlags.All);
      query.path = this.path;
      this.$api.execute(query).then(res => {
        const temp = res as Common.LoadResult;        
        this.items = temp.result;
        //ここでスロット内のSideBarGroupを検索して詰めていく
        if (this.$scopedSlots.default)
        {
          this.$scopedSlots.default(null).forEach(node =>{
            if (node.componentInstance instanceof Components.SideBarMenuItem){
              var menu = node.componentInstance as Components.SideBarMenuItem;

              menu.$on('selected',this.onSelected);         
              this.$nextTick(()=>{
                  if (this.$route.fullPath == menu.to) this.onSelected(menu);
              });
              //menu.toと同じパスを持つ項目を追加する
              var path = menu.to;
              if (path.indexOf("?") > -1)path = path.substring(0, menu.to.indexOf("?"));
              var targets = new Array();
              this.items.forEach(obj => {
                if (obj.path == path)targets.push(obj);
              });
              menu.items = targets;
            }
          });

        }
        this.$forceUpdate();
      });      
    }
  }

  lastCollapsed : Components.SideBarMenuItem;
  public onSelected(menu : Components.SideBarMenuItem){
    if (menu.opened == false){
      //前回のメニューを閉じる
      if (this.lastCollapsed && this.lastCollapsed.opened) this.lastCollapsed.collapse();
      this.lastCollapsed = menu;
      this.lastCollapsed.collapse();
    }
    //お気に入りのカウントを集計する
    if (menu.query){
      this.$api.execute(new Common.CountQuery(menu.items.map(obj =>JSON.parse(obj.json)),menu.query)).then(results =>{
        menu.items.forEach((item,index) => item.count = results[index]);
      });
    }    

  }
  public getPath(index: number) {
    const item = this.items[index];
    return item.path + '?favorite=' + item.key;
  }

  public getPath2(index: number) {
    const item = this.sharedItems[index];
    return item.path + '?favorite=' + item.key;
  }

}
